import React from 'react'

import { StCredits } from './style.css'

const Credits = () => (
  <StCredits>
    <div className="creditsWrapper">
      <h2>Créditos</h2>

      <p className="font-sans m-0 p-0 ">
        <span>Coordinación y edición:</span>
      </p>
      <p className="font-sans m-0 mb-4 p-0 ">
        <strong>Tania Opazo</strong>
        <strong>Sebastián Rivas</strong>
        <strong>Andrés Muñoz</strong>
      </p>
      <p className="font-sans m-0 p-0 ">
        <span>Periodistas:</span>
      </p>
      <p className="font-sans m-0 mb-4 p-0 ">
        <strong>Valentina Danker</strong>
        <strong>Magdalena Fuenzalida</strong>
        <strong>Sofía Gómez</strong>
      </p>
      <p className="font-sans m-0 p-0 ">
        <span>Data Scraping:</span>
      </p>
      <p className="font-sans m-0 mb-4 p-0 ">
        <strong>Víctor González</strong>
      </p>

      <p className="font-sans m-0 p-0 ">
        <span>Diseño:</span>
      </p>
      <p className="font-sans m-0 mb-4 p-0 ">
        <strong>Luis Rodríguez</strong>
      </p>
      <p className="font-sans m-0 p-0 ">
        <span>Análisis UX:</span>
      </p>
      <p className="font-sans m-0 mb-4 p-0 ">
        <strong>Carla Pía Ruiz</strong>
      </p>
      <p className="font-sans m-0 p-0 ">
        <span>Desarrollo:</span>
      </p>
      <p className="font-sans m-0 mb-4 p-0 ">
        <strong>Álex Acuña Viera</strong>
      </p>
    </div>
  </StCredits>
)

export default Credits
